import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Form } from 'antd';

import { checkPrivilege } from 'helpers/roles';
import { useDebounce } from 'hooks';

import Button from 'components/Button';
import { TCM } from 'components/tcm';

import { DEBOUNCE_SEARCH_TIME } from 'settings';

import {
  approveRole as approveRoleAction,
  approveRoleReset as approveRoleResetAction,
} from 'redux/user/actions';

import {
  setSearch as setSearchAction,
} from 'redux/company/actions';

import { KEYS } from './data';

import {
  Root, Header, Title, FormStyled, Footer, ErrorMessage,
} from './style';

const getAvailableRoles = ({ list = [], isUserInternal }) =>
  list
    .filter(({ forExternal }) => forExternal === !isUserInternal)
    .map((elem) => ({ id: elem.id, name: elem.name }));

const ModalHeader = () => (
  <Header>
    <Title>Добавить новую роль</Title>
  </Header>
);

const { COMPANY, DEALER_CENTER, ROLE } = KEYS;

function AddRole({
  // passed
  close,
  role,

  companyList,
  companyListIsLoading,
  companyListIsLoaded,
  companyListError,
  resetCompanyList,
  fetchCompanyList,

  roleList,
  roleListIsLoading,
  roleListIsLoaded,
  roleListError,

  userId,
  visible,
  isUserInternal,

  // connect,
  isLoading,
  isLoaded,
  error,
  errors,

  // actions
  approveRole,
  approveRoleReset,
  setSearch,
}) {
  const [form] = Form.useForm();
  const [isMounted, setIsMounted] = useState(false);
  const [dealerCentersByCompany, setDealerCentersByCompany] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [availableRolesList, setAvailableRolesList] = useState([]);
  const [isValidated, setIsValidated] = useState(true);
  const [companies, setCompanies] = useState([]);
  const location = useLocation();
  const [isRoleTCM, setIsRoleTCM] = useState(false);

  const [searchTerm, setSearchTerm] = useState(null);
  const debouncedSearchTerm = useDebounce(searchTerm, DEBOUNCE_SEARCH_TIME);

  const handleCompanyChange = useCallback((companyId) => {
    form.setFieldsValue({
      [DEALER_CENTER.key]: '',
    });

    const selectedCompany = companyList.find((e) => e.id === companyId);

    if (selectedCompany) {
      if (Array.isArray(selectedCompany.subsidiariesList)) {
        if (isRoleTCM) {
          setDealerCentersByCompany(
            selectedCompany.subsidiariesList
              .filter((item) => item.krifOrganizationName)
              .map((item) => ({ label: item.name, value: item.id })),
          );
        } else {
          setDealerCentersByCompany(
            selectedCompany.subsidiariesList.map((item) => ({ label: item.name, value: item.id })),
          );
        }
        if (selectedCompany.subsidiariesList.length === 1) {
          form.setFields([
            ...([{ name: DEALER_CENTER.key, value: selectedCompany.subsidiariesList[0].id }]),
          ]);
        }
      }
    }
  }, [form, companyList, isRoleTCM]);

  function handleSearchCompany(value) {
    setSearchTerm(value);
  }

  function handleSearchDealerCenter(value) {
    const companyId = form.getFieldValue(COMPANY.key);
    const selectedCompany = companyList.find((e) => e.id === companyId);
    const { subsidiariesList } = selectedCompany;

    if (Array.isArray(subsidiariesList) && subsidiariesList.length > 0) {
      setDealerCentersByCompany(
        subsidiariesList
          .map((item) => ({ ...item, search: item.name ? item.name.toLowerCase() : '' }))
          .filter((item) => item.search.includes(value.toLowerCase())),
      );
    } else {
      setDealerCentersByCompany([]);
    }
  }

  function handleBlur(_e, name) {
    form.validateFields([name]);
  }

  function handleFocus(_e, name) {
    form.setFields([{ name, errors: [] }]);
  }

  function handleValuesChange(value) {
    const { ROLE, COMPANY } = value;

    if (ROLE) {
      const isRoleTCM = availableRolesList.find((item) => (item.id === ROLE)
          && ((item.name === 'ТСМ Менеджер ДЦ') || (item.name === 'ТСМ Сотрудник ДЦ')));

      if (isRoleTCM && isRoleTCM.id) {
        setIsRoleTCM(true);
      } else {
        setIsRoleTCM(false);
      }
    }

    if (Object.prototype.hasOwnProperty.call(value, 'COMPANY')
      && !COMPANY
      && isSearched
      && setSearchTerm
    ) {
      setSearch({ search: '' });
      setIsSearched(false);
      setSearchTerm(null);
    }
  }

  function handleFinish(values) {
    const { [COMPANY.key]: company, [DEALER_CENTER.key]: point, [ROLE.key]: role } = values;

    approveRole({
      userId,
      [COMPANY.apiKey]: company,
      [DEALER_CENTER.apiKey]: point,
      [ROLE.apiKey]: role,
      isInternal: isUserInternal,
    });
    setIsValidated(false);
  }

  function reset() {
    setIsValidated(true);
    form.resetFields();
  }

  function cancel() {
    if (isLoaded) {
      reset();
    }
    close();
  }

  useEffect(() => {
    if (checkPrivilege(role.MANAGEMENT.ASSIGN_ROLE_TO_WEB_USERS) && visible) {
      fetchCompanyList();
    }
  }, [
    fetchCompanyList,
    role,
    visible,
  ]);

  useEffect(() => {
    // we do not have access to `form` hook till the <form> component is rendered
    if (visible) {
      setIsMounted(true);
    } else {
      form.resetFields();
      setIsSearched(false);
      resetCompanyList();
      setIsRoleTCM(false);
      approveRoleReset();
      form.setFields([
        { name: ROLE.key, value: '', errors: [] },
        { name: DEALER_CENTER.key, value: '', errors: [] },
        ...[(Array.isArray(companyList) && companyList.length > 1 ? { name: COMPANY.key, value: '', errors: [] } : {})],
      ]);
    }
  }, [
    visible,
    setIsMounted,
    approveRoleReset,
    form,
    companyList,
    resetCompanyList,
  ]);
  /* start: write fetch errors
  if we failed to fetch one of the lists - get an error message and put it under the input
 */
  useEffect(() => {
    if (isMounted && companyListError) {
      form.setFields([{ name: COMPANY.key, errors: [companyListError] }]);
    }
  }, [isMounted, companyListError, form]);

  useEffect(() => {
    if (isMounted && roleListError) {
      form.setFields([{ name: ROLE.key, errors: [roleListError] }]);
    }
  }, [isMounted, roleListError, form]);
  /* end: write fetch errors */

  useEffect(() => {
    if (isMounted && isLoaded) {
      close();
      setIsValidated(true);
      form.resetFields();
      approveRoleReset();
    }
  }, [isMounted, isLoaded, form, close, approveRoleReset]);

  useEffect(() => {
    if (!isValidated && !isLoading && Array.isArray(errors) && errors.length > 0) {
      const errorsFlat = errors.map((f) =>
        f.fieldName
          .replace('data.', '')
          .split('.')
          .reduceRight((p, k) => ({ [k]: p }), f.messages[0]));
      const {
        [COMPANY.apiKey]: company,
        [DEALER_CENTER.apiKey]: point,
        [ROLE.apiKey]: role,
      } = errorsFlat.reduce((p, c) => ({ ...p, ...c }), {});

      form.setFields([
        ...(company ? [{ name: COMPANY.key, errors: [company] }] : []),
        ...(point ? [{ name: DEALER_CENTER.key, errors: [point] }] : []),
        ...(role ? [{ name: ROLE.key, errors: [role] }] : []),
      ]);
      setIsValidated(true);
    }
  }, [errors, isLoading, form, isValidated, setIsValidated]);

  useEffect(() => {
    if (roleListIsLoaded) {
      const roles = getAvailableRoles({ list: roleList, isUserInternal });
      setAvailableRolesList(roles.map((item) => ({ label: item.name, value: item.id })));
    }
  }, [roleList, roleListIsLoaded, isUserInternal]);

  useEffect(() => {
    if (companyListIsLoaded && companyList.length === 1 && companyList[0].id) {
      form.setFields([
        ...([{ name: COMPANY.key, value: companyList[0].id }]),
      ]);
      handleCompanyChange(companyList[0].id);
    }
  }, [companyListIsLoaded, companyList, form, handleCompanyChange]);

  useEffect(() => {
    const companyId = form.getFieldValue(COMPANY.key);
    if (companyId) {
      handleCompanyChange(companyId, isRoleTCM);
    }
  }, [form, isRoleTCM, handleCompanyChange]);

  useEffect(() => {
    if ((debouncedSearchTerm === searchTerm) && (searchTerm !== null)) {
      setSearch({ search: searchTerm });
      form.setFieldsValue({
        [DEALER_CENTER.key]: '',
      });
      setIsSearched(true);
    }
  }, [debouncedSearchTerm, searchTerm, setSearch, form]);

  useEffect(() => {
    if (companyListIsLoaded) {
      setCompanies(companyList.map((item) => ({ label: item.name, value: item.id })));
    }
  }, [companyListIsLoaded, companyList]);

  useEffect(() => {
    if (availableRolesList.length === 1 && visible && roleListIsLoaded) {
      form.setFields([
        { name: ROLE.key, value: availableRolesList[0].value },
      ]);
    }
  }, [availableRolesList, form, roleListIsLoaded, visible]);

  return (
    <Root
      visible={visible}
      title={<ModalHeader location={location} />}
      onCancel={cancel}
      footer={null}
    >
      <FormStyled
        name="AddRole"
        layout="vertical"
        hideRequiredMark
        form={form}
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
      >
        {!isUserInternal && (
          <>
            <Form.Item
              name={COMPANY.key}
              label={COMPANY.title}
              rules={COMPANY.rules}
              validateFirst
              validateTrigger="onBlur"
            >
              <TCM.Select
                name={COMPANY.key}
                showSearch
                onSearch={handleSearchCompany}
                onFocus={(e) => handleFocus(e, COMPANY.key)}
                onBlur={(e) => handleBlur(e, COMPANY.key)}
                onChange={handleCompanyChange}
                loading={companyListIsLoading}
                disabled={
                  !isSearched && (companyListIsLoading || companyList.length === 1)
                }
                filterOption={false}
                options={companies}
                hasDefault={false}
              />
            </Form.Item>

            <Form.Item
              name={DEALER_CENTER.key}
              label={DEALER_CENTER.title}
              // так как нет нормальной возможности завести проверку на внешнего пользователя в data.jsx
              // для внешнего пользователя необязательное поле
              rules={(isRoleTCM || isUserInternal) ? DEALER_CENTER.rules : []}
              validateFirst
              validateTrigger="onBlur"
            >
              <TCM.Select
                showSearch
                onSearch={handleSearchDealerCenter}
                name={DEALER_CENTER.key}
                onFocus={(e) => handleFocus(e, DEALER_CENTER.key)}
                onBlur={(e) => handleBlur(e, DEALER_CENTER.key)}
                loading={companyListIsLoading}
                disabled={companyListIsLoading || dealerCentersByCompany.length === 1}
                filterOption={false}
                options={dealerCentersByCompany}
              />
            </Form.Item>
          </>
        )}
        <Form.Item
          name={ROLE.key}
          label={ROLE.title}
          rules={ROLE.rules}
          validateFirst
          validateTrigger="onBlur"
        >
          <TCM.Select
            name={ROLE.key}
            onFocus={(e) => handleFocus(e, ROLE.key)}
            onBlur={(e) => handleBlur(e, ROLE.key)}
            loading={roleListIsLoading}
            disabled={companyListIsLoading || roleListIsLoading || availableRolesList.length === 1}
            options={availableRolesList}
            hasDefault={false}
          />
        </Form.Item>

        {error && !isLoading && <ErrorMessage>{error}</ErrorMessage>}

        <Footer>
          <Button
            type="ghost"
            shape="square"
            size="small"
            onClick={cancel}
            htmlType="button"
          >
            Отменить
          </Button>
          <Button
            type="primary"
            shape="square"
            size="small"
            htmlType="submit"
            loading={isLoading}
          >
            Сохранить
          </Button>
        </Footer>
      </FormStyled>
    </Root>
  );
}

export default connect(
  (state) => ({
    userRole: state.auth.role,
    isLoading: state.user.approveRole.isLoading,
    isLoaded: state.user.approveRole.isLoaded,
    error: state.user.approveRole.error,
    errors: state.user.approveRole.errors,
  }),
  {
    approveRole: approveRoleAction,
    approveRoleReset: approveRoleResetAction,
    setSearch: setSearchAction,
  },
)(AddRole);
